import {MediaGalleryAssetType} from "../types/MediaGalleryAssetType";
import {MediaGalleryFilterType} from "../types/MediaGalleryFilterType";


export enum MediaGalleryStateModeEnum {
    Search = 'search',
    Collection = 'collection',
}

export type MediaGalleryStateType = {
    mode: MediaGalleryStateModeEnum,
    authenticated: boolean,
    acceptedTerms: boolean,
    runningRequestIdentifiers: string[],
    reloadAssetsOnNavigation: boolean,
    reloadCollectionAssetsOnNavigation: boolean,
    keyword: string,
    assets: MediaGalleryAssetType[]
    totalAssets: number,
    filters: MediaGalleryFilterType[]
    selectedAssetIds: string[],
    collectionKeyword: string,
    collectionAssets: MediaGalleryAssetType[],
    totalCollectionAssets: number,
    collectionFilters: MediaGalleryFilterType[],
    selectedCollectionAssetIds: string[],
    collectedAssetCount: number
}
